import { useCallback } from "react";
import { Flex, Box, Text } from "@chakra-ui/react";

// assets
import { Arrow } from "icons";

import { useStakeProvider } from "dapp-sdk";
import { IconBackgroundContainer, InfoCardBody } from "theme";

import InfoCard from "@components/InfoCard";
import Icon from "@components/Icon";

import { StrapiAuditsData } from "@customtypes/global";

import { trackEvent } from "@utils/firebase";
import { getAuditsIcon } from "@utils/common";
import { AUDIT_TYPE } from "@constants/analytics";

interface AuditsCardProps {
  title?: string;
  subTitle?: string;
  auditsData: StrapiAuditsData[];
}

const AuditsCard = ({ title, subTitle, auditsData }: AuditsCardProps) => {
  const { firebaseEventsData } = useStakeProvider();

  const onAuditsItemClick = useCallback(
    (key: string) => {
      trackEvent(AUDIT_TYPE, {
        audit_type: key,
        ...firebaseEventsData,
      });
    },
    [firebaseEventsData]
  );

  return (
    <InfoCard title={title} subTitle={subTitle}>
      <InfoCardBody>
        {auditsData.map((data, index) => (
          <a
            href={data?.link ? data.link : undefined}
            target="_blank"
            rel="noreferrer"
            onClick={() => onAuditsItemClick(data.key || "")}
            key={data?.key || index}
          >
            <Flex
              justifyContent="space-between"
              alignItems="center"
              mt={index > 0 ? "1rem" : 0}
            >
              <Flex alignItems="center">
                <IconBackgroundContainer>
                  <Box
                    w={{ base: "14px", lg: "20px" }}
                    h={{ base: "12px", lg: "18px" }}
                  >
                    {data.key && (
                      <Icon
                        width="100%"
                        height="100%"
                        color="textSecondary"
                        Icon={getAuditsIcon(data.key)}
                      />
                    )}
                  </Box>
                </IconBackgroundContainer>
                <Text fontSize="14px" ml="1rem" fontWeight="600">
                  {data.title}
                </Text>
              </Flex>
              <Box>
                <Icon
                  height="24px"
                  width="24px"
                  color="textPrimary"
                  Icon={Arrow}
                />
              </Box>
            </Flex>
          </a>
        ))}
      </InfoCardBody>
    </InfoCard>
  );
};

export default AuditsCard;
